<script lang="ts" setup>
import { onMounted } from "vue";
import { useReservationLogs } from "@/composables/reactive/useReservationLogs";
import TruckReservationsTable from "@/views/fleets/components/TruckReservationsTable.vue";
import type { TruckDto } from "@/api/trucks/dto/truck.dto";

const props = defineProps<{
  truck: TruckDto;
}>();

const {
  reservationLogs,
  reservationLogsTotal,
  reservationLogsParams,
  reservationLogsLoading,
  fetchReservationLogs,
  changeReservationLogsPage,
  changeReservationLogsPageSize,
} = useReservationLogs(() => props.truck.id);

onMounted(async () => {
  await fetchReservationLogs();
});
</script>

<template>
  <truck-reservations-table
    :items="reservationLogs"
    :loading="reservationLogsLoading"
    :page="reservationLogsParams.page"
    :page-size="reservationLogsParams.pageSize"
    :total="reservationLogsTotal"
    :truck-number="props.truck.number"
    @update:page="changeReservationLogsPage"
    @update:page-size="changeReservationLogsPageSize"
  />
</template>
